import Navbar from "../sections/web_core/Navbar";
import SecondHeroSection from "../sections/web_core/SecondHeroSection";
import ServicesGrid from "../sections/web_core/ServiceGrid";
import { services } from "../sections/Data/service";         
import SERVICES_BG from "../Assets/Services/imgi_15_page-title.jpg";
import Footer from "../sections/web_core/Footer";
import { useNavigate } from "react-router-dom";
const Services = () => {
  return (
    <div className="flex flex-col min-h-screen">
      const navigate = useNavigate();
      <Navbar />
    
      <SecondHeroSection
        title="Our Services"
        subtitle="Online Islamic education for all ages"
        bgImage={SERVICES_BG}
        breadcrumbs={[
          { label: "Home", href: "/" },
          { label: "Services" },
        ]}
      />

    
      <ServicesGrid data={services} />
      <Footer/>
    </div>
    
  );
};

export default Services;
